var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.searchClass},[_c('font-awesome-icon',{attrs:{"icon":"search"}}),_c('input',{staticClass:"SearchBar__input",attrs:{"type":"text","placeholder":_vm.SEARCH_CHAPTER},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"input":function($event){_vm.onChange(_vm.name, $event)}}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04d85b1c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchBar/SearchBar.vue
// module id = null
// module chunks = 